import React, { Component } from "react";
import {
  Row,
  Label,
  Alert,
  Button,
  Dropdown,
  DropdownToggle
} from "reactstrap";
import { BeatLoader } from "react-spinners";
import Select from "react-select";
import sortByPropText from "../../../helpers/content/manageSets/sortByPropText";
class StudentLicenseFilters extends Component {
  state = {
    teachersDropdownOpen: false,
    classesDropdownOpen: false,
    filter: "",
    selectedTeacher: null,
    selectedClass: null,
    newfilteredGroupData: null,
    isDuplicate: false
  };
  teachersToggle = () => {
    this.setState({ teachersDropdownOpen: !this.state.teachersDropdownOpen });
  };
  classesToggle = () => {
    this.setState({ classesDropdownOpen: !this.state.classesDropdownOpen });
  };
  changeSelectedTeacher = selectedOption => {
    if (selectedOption.label === "----") {
      this.setState({ selectedTeacher: null, selectedClass: null }, () => {
        this.props.getSelectedTeacher(selectedOption);
      });
    } else {
      this.setState(
        { filter: "", selectedClass: null,selectedTeacher: selectedOption.selectedTeacher },
        () => this.props.getSelectedTeacher(this.state.selectedTeacher)
      );
    }
  };
  changeSelectedClass = selectedOption => {
    if (selectedOption.label === "----") {
      this.setState({ selectedClass: null }, () => {
        this.props.getSelectedClass(selectedOption);
      });
    } else {
      this.setState(
        { filter: "", selectedClass: selectedOption.selectedClass },
        () => this.props.getSelectedClass(this.state.selectedClass)
      );
    }
  };
  createListFromTeachers() {
    if (this.props.teachersInSchool) {
      if (this.props.teachersInSchool[0]) {
        if (!(this.props.teachersInSchool[0]["id"] === "deselectTeachers")) {
          this.props.teachersInSchool.push({
            fullName: "----",
            id: "deselectTeachers"
          });
        }
      }

      let teachers = sortByPropText(
        this.props.teachersInSchool,
        "fullName",
        0
      ).map(teacher => {
        return {
          label: teacher.fullName,
          value: teacher.id,
          selectedTeacher: teacher
        };
      });
      return teachers;
    }
  }
  createListFromClasses() {
    if (this.props.classesInSchool) {
      if (this.props.classesInSchool[0]) {
        if (!(this.props.classesInSchool[0]["id"] === "deselectClasses")) {
          this.props.classesInSchool.push({
            name: "----",
            id: "deselectClasses"
          });
        }
      }
      let classes = sortByPropText(this.props.classesInSchool, "name", 0).map(
        classy => {
          return {
            label: classy.name,
            value: classy.id,
            selectedClass: classy
          };
        }
      );
      return classes;
    }
  }
  getClassesDropdown() {
    return (
      <React.Fragment>
        {
          <Select
            placeholder={"Classes"}
            isDisabled={this.state.selectedTeacher ? false : true}
            options={
              this.props.classesInSchool
                ? this.createListFromClasses()
                : ["No Data"]
            }
            onChange={this.changeSelectedClass}
            value={
              this.state.selectedClass ? this.state.selectedClass.label : "---"
            }
          />
        }
      </React.Fragment>
    );
  }
  render() {
    const {
      sm,
      md,
      lg,
      xl,
      teachersInSchool,
      classesInSchool,
      resetFilter
    } = this.props;
    const {
      teachersDropdownOpen,
      classesDropdownOpen,
      selectedTeacher
    } = this.state;
    const { teachersToggle, classesToggle } = this;
    return (
      <Row>
        <Dropdown
          className="col-md-5"
          isOpen={teachersDropdownOpen}
          toggle={teachersToggle}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            onClick={teachersToggle}
            aria-expanded={teachersDropdownOpen}
          >
            <Label>{`Teachers`}</Label>
            <Select
              placeholder={"Teachers"}
              options={this.createListFromTeachers()}
              onChange={this.changeSelectedTeacher}
              value={
                this.state.selectedTeacher
                  ? this.state.selectedTeacher.label
                  : "---"
              }
            />
          </DropdownToggle>
        </Dropdown>
        <Dropdown
          className="col-md-5"
          isOpen={classesDropdownOpen}
          toggle={classesToggle}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            onClick={classesToggle}
            aria-expanded={classesDropdownOpen}
          >
            <Label>{`Classes`}</Label>
            {this.getClassesDropdown()}
          </DropdownToggle>
        </Dropdown>
        <div className="col-md-2 reset-button">
          <Button
            onClick={() => {
              this.setState(
                { selectedTeacher: null, selectedClass: null },
                () => {
                  this.props.resetFilter();
                }
              );
            }}
          >
            Reset
          </Button>
        </div>
      </Row>
    );
  }
}

export default StudentLicenseFilters;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/StudentLicenseFilters.js